import { URLS } from "./url/url";
import { remToPx } from "@/shared/utils/viewmode";

export const validateDate = (date) => {
  return date.getFullYear() +
    "-" + parseDate(date.getMonth() + 1) +
    "-" + parseDate(date.getDate());
};

export const parseDate = (num) => {
  const norm = Math.floor(Math.abs(num));
  return (norm < 10 ? "0" : "") + norm;
};

export const getDate = (date) => date ? new Date(date) : new Date();

export const makeSubsReadUrl = (date, bookId) => {
  let url = `${URLS.subscription}${URLS.read}/${date}/`;

  if (bookId) {
    url += bookId;
  }

  return url;
};

export const createMoreIcon = (content, text) => {
  const re = /<\/[^>]+>$/g;
  const lastTag = content.match(re);

  if (!lastTag) {
    return "";
  }

  const moreIcon = `<span class="subs-arrow-container">
  <span class="subs-more-text">${text}</span>
  <i class="subs-more-icon icon-right" ></i>  
  </span>${lastTag[0]}`;

  return content.replace(re, moreIcon);
};

export const countLetters = (text) => text.replace(/(<([^>]+)>)/g, "").length;

export const splitText = (text, maxLetters) => {
  let cloned = text;
  let index = -1;

  while (cloned.length > maxLetters) {
    cloned = cloned.slice(0, index);
    index--;
  }

  return cloned;
};

export const convertToString = (elements) => {
  let updatedContent = "";

  elements.forEach((el, index) => {
    const lastIndex = elements.length - 1 === index;
    if (lastIndex) {
      updatedContent += `<${el.tag}>${el.text += "... "}</${el.tag}>`;
    } else {
      updatedContent += el.html;
      updatedContent += "\n";
    }
  });

  return createMoreIcon(updatedContent,"More");
};

export const cropHtmlContent = (width, content, isMobile = false) => {
  const re = /<\w[^>]*>(.*?)<\/([^>]+)>$/;

  const ratio = isMobile ? remToPx(0.65) : remToPx(0.5); // ratio = one letter ~width

  const maxAmountOfLine = isMobile ? 4 : 6;
  const maxLettersInRow = Math.round(width / ratio);
  const elements = [];

  for (let i = 0, rowCount = 0; i < content.length; i++) {
    const found = content[i].match(re);

    if (rowCount < maxAmountOfLine) {
      if (found) {
        const [html, text, tag] = found;
        const amount = countLetters(text);

        if (amount <= maxLettersInRow) {
          rowCount++;
          elements.push({ tag, text, html });
        } else {
          const row = Math.ceil(amount / maxLettersInRow);
          const nextRowCount = row + rowCount;
          if (nextRowCount > maxAmountOfLine) {
            const restLines = maxAmountOfLine - rowCount;
            const maxLetters = maxLettersInRow * restLines;
            rowCount += restLines;
            elements.push({ tag, text: splitText(text, maxLetters), html });
          } else {
            rowCount += row;
            elements.push({ tag, text, html });
          }
        }
      }
    }
  }

  return convertToString(elements);
};
